'use strict';

require('normalize.css/normalize.css');
require('./index.css');